<!-- @format -->
<template>
	<div class="pcp-mo-menu">
		<list-menu
			v-if="route.query.menuType === 'list'"
			:menus="menuStore.menusRes"
			:root-menu="moglobalStore.curTabbarMenu[moglobalStore.tabbar.active]"
		/>
		<grid-menu
			v-else
			:menus="menuStore.menusRes"
			:root-menu="moglobalStore.curTabbarMenu[moglobalStore.tabbar.active]"
		/>
	</div>
</template>

<script lang="ts" setup>
	import { useMenuStore } from '@/store/modules/menu';
	import GridMenu from '@/p-components/mobile/pcp-mo-menu/grid-menu.vue';
	import ListMenu from '@/p-components/mobile/pcp-mo-menu/list-menu.vue';
	import { useMoGlobalStoreWithOut } from '@/store/modules/moglobal';
	const moglobalStore = useMoGlobalStoreWithOut();
	const menuStore = useMenuStore();
	const route = useRoute();
</script>

<style scoped lang="scss"></style>
